import React from 'react';
import { FormGroup, ControlLabel, FormControl, Checkbox } from 'react-bootstrap';
import PropTypes from 'prop-types';

const ServiceDescriptionForm = ({ id, formData, onChange }) => (
  <div className="services-import__list-service-description">
    <FormGroup>
      <Checkbox inline checked={formData.dripfeed} name="dripfeed" onChange={onChange}>
        <span className="icon fas fa-tint" />
        {' '}
        Drip-feed
      </Checkbox>
      {formData.refill !== undefined ? (
        <Checkbox inline checked={formData.refill} name="refill" onChange={onChange}>
          <span className="icon far fa-sync-alt" />
          {' '}
          Refill
        </Checkbox>
      ) : null}
      {formData.cancel !== undefined ? (
        <Checkbox inline checked={formData.cancel} name="cancel" onChange={onChange}>
          <span className="icon far fa-ban" />
          {' '}
          Cancel allowed
        </Checkbox>
      ) : null}
    </FormGroup>

    <FormGroup controlId={`name-${id}`}>
      <ControlLabel>Name</ControlLabel>
      <FormControl name="name" value={formData.name} onChange={onChange} />
    </FormGroup>

    <FormGroup controlId={`description-${id}`} className="mb-0">
      <ControlLabel>Description</ControlLabel>
      <FormControl rows={5} name="description" componentClass="textarea" value={formData.description || ''} onChange={onChange} />
    </FormGroup>
  </div>
);

ServiceDescriptionForm.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  formData: PropTypes.object,
  onChange: PropTypes.func,
};

export default ServiceDescriptionForm;
